import { render, staticRenderFns } from "./GoogleAssistantSettingsCard.vue?vue&type=template&id=8ca5a8da"
import script from "./GoogleAssistantSettingsCard.vue?vue&type=script&lang=ts"
export * from "./GoogleAssistantSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports